module.exports = __webpack_public_path__ + "img/live-zbyy.eeefb9c5.png";